import { User } from 'users/domain/user'
import { formatDate, formatHour } from '../../utils/formatting'

interface UserBackendResponse {
    id?: number
    name: string
    email: string
    role_id: number
    warehouse_id?: number
    password?: string
    confirm_password?: string
    warehouse_name?: string
    created_at: string
}

export class UserAdapter {
    static toDomain(data: UserBackendResponse): User {
        return {
            id: data.id,
            name: data.name,
            email: data.email,
            roleId: data.role_id,
            warehouseId: data.warehouse_id,
            password: data.password,
            confirmPassword: data.confirm_password,
            warehouse_name: data.warehouse_name,
            createdAt: `${formatDate(data.created_at)} ${formatHour(data.created_at)}`,
        }
    }

    static toDomainList(dataList: UserBackendResponse[]): User[] {
        return dataList.map((data) => this.toDomain(data))
    }
}
